module.exports = __webpack_public_path__ + "static/img/image3.e2205a71.png";